import { fetcher } from "#app/http/fetcher";

export const refresh = async (
  previousRefreshToken: string,
): Promise<{ accessToken: string; refreshToken: string }> => {
  try {
    const { accessToken, refreshToken } = await fetcher.post<
      { refreshToken: string },
      {
        accessToken: string;
        refreshToken: string;
      }
    >("/auth/refresh", {
      body: {
        refreshToken: previousRefreshToken,
      },
    });

    return { accessToken, refreshToken };
  } catch {
    throw new Error("No refresh token");
  }
};
